import { defineStyle } from "@chakra-ui/react";

const Link = {
  variants: {
    primary: defineStyle({
      color: "primary.700",
      _dark: {
        color: "primary.400",
      },
    }),
  },
  defaultProps: {
    variant: "primary",
  },
};

export default Link;
